import React from "react";
import {
  InputWrapper,
  LabelWrapper,
  Label,
  selectStyles,
  ErrorContainer,
  ErrorWrapper,
} from "../CreateForm/Styles";
import Select from "react-select";

const PeriodSelect = (props) => {
  return (
    <InputWrapper>
      <LabelWrapper>
        {props.label && (
          <Label>
            <h3>{props.label}</h3>
          </Label>
        )}
        <ErrorContainer>
          <Select
            placeholder={props.placeholder}
            options={periodOptions}
            styles={selectStyles}
            value={props.inputs?.[props.name] || null}
            classNamePrefix="styled"
            onChange={(val) => props.onSelectChange(val, props.name)}
            className={props.error && "invalid"}
          />
          {props.error && (
            <ErrorWrapper>
              <span>{props.error?.msg}</span>
            </ErrorWrapper>
          )}
        </ErrorContainer>
      </LabelWrapper>
    </InputWrapper>
  );
};

const periodOptions = [
  { value: "daily", label: "day" },
  { value: "weekly", label: "week" },
  { value: "monthly", label: "month" },
  { value: "yearly", label: "year" },
];

export default PeriodSelect;
